import { createContext, useContext } from 'react';

export const FindCourseContext = createContext({
  openFindCourse: () => {}
});

export function useFindCourse() {
  return useContext(FindCourseContext);
}
